import React from "react";

import {MuiIcon, MuiIconExternalProps} from "../MuiIcon";

export const TableIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\uf191'}</MuiIcon>
    );
}